/**
 * Native <select> that renders native <option>s.
 *
 * If you bells and whistles, use Dropdown.
 */

import { find } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import Option from '../SelectOption';

class Select extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.onChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState(() => {
      return {
        value: newProps.value
      };
    });
  }

  getSelectedOption() {
    const { options, valueKey } = this.props;
    const { value } = this.state;

    return find(options, (opt) => opt[valueKey] === value || opt[valueKey] === parseInt(value, 10));
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    }, () => {
      const {
        onChange,
      } = this.props;

      if (onChange) {
        onChange(this.getSelectedOption(), event, this.state.value);
      }
    });
  }

  getOptions() {
    const {
      theme,
      valueKey,
      labelKey,
      options,
    } = this.props;

    return options.map((option, i) => {
      const val = option[valueKey || 0];
      const label = option[labelKey || 0];
      return <Option key={i} theme={theme} value={val}>{label}</Option>
    });
  }

  render() {
    const {
      theme,
      variant,
      children,
      isMobile,
      ariaLabel,
      id,
      role,
      ariaControls,
      ariaOwns
    } = this.props;

    const {
      value,
    } = this.state;

    const hasTheme = theme && theme.select;
    const selectTheme = hasTheme && hasTheme.select;
    const selectClassname = classNames(selectTheme, variant, { isMobile });

    return (
      <select 
        className={selectClassname} 
        value={value} 
        onChange={this.onChange} 
        aria-label={ariaLabel} 
        id={id}
        role={role} 
        aria-controls={ariaControls} 
        aria-owns={ariaOwns} >
        {children || this.getOptions()}
      </select>
    );
  }
}

Select.propTypes = {
  theme: PropTypes.object,
  variant: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.any,
  isMobile: PropTypes.bool,
  onChange: PropTypes.func,
};

Select.defaultProps = {
  options: [],
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/index.js